import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import CouponFill from 'yoda-core-components/lib/assets/svg/CouponFill.svg';
import classNames from 'classnames/bind';
import { ANALYTICS_ACTIONS_FIND_COUPON } from 'yoda-checkout-components/lib/common/Constants';
import Button from 'yoda-core-components/lib/components/Button';
import get from 'lodash/get';
import { AMR_CART_VIEW_TODAYS_COUPONS } from 'yoda-checkout-components/lib/common/AmrConstants';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import * as checkoutAnalyticsAction from 'yoda-checkout-components/lib/actions/CheckoutAnalyticsAction';
import * as slidePanelActions from 'yoda-checkout-components/lib/actions/SlidePanelAction';
import * as coCouponActions from 'yoda-checkout-components/lib/actions/COCouponAction';
import * as serviceErrorActions from 'yoda-checkout-components/lib/actions/ServiceErrorHandlerAction';
import * as styles from './FindBestCoupon.css';

const cx = classNames.bind(styles);

/* wrapper component to be used whereever find best coupon is needed in the app
 * Wraps  CouponPanel and the Branded FindBestCoupon link  together
 */
export class FindBestCoupon extends Component {
    static defaultProps = {
        noCouponText: '',
        fpacEnabledBestCouponText: '',
        enableBestCouponCTA: true,
    };

    static propTypes = {
        actions: PropTypes.objectOf(PropTypes.func).isRequired,
        fpacEnabledBestCouponText: PropTypes.string,
        noCouponText: PropTypes.string,
        enableBestCouponCTA: PropTypes.bool,
    };

    constructor(props) {
        super(props);
        this.openCouponPanel = this.openCouponPanel.bind(this);
    }

    openCouponPanel(e) {
        e.preventDefault();
        this.props.actions.clearServiceErrorMessage();
        // Open the coupons slideover
        this.props.actions.showCouponsPanel(true);
        // Making this call every time the panel is open to refresh the coupon discounts data.
        // The discounts will be different if the items in the bag has changed.
        this.props.actions.getCOCouponsAction(true);
        // Trigger 'findCoupon' event for DA
        this.props.actions.clickEventAnalyticsAction(ANALYTICS_ACTIONS_FIND_COUPON);
    }

    render() {
        const { noCouponText, fpacEnabledBestCouponText, enableBestCouponCTA } = this.props;
        const couponLink = dt(['h-10', 'text-center', 'flex', 'w-full']);
        const bestCouponWrapperCss = dt([
            'flex',
            'lg:mx-0',
            'w-full',
            'flex',
            'justify-between',
            'items-center',
            'md:mx-3',
            'lg:mx-0',
        ]);
        const findBestCouponCss = dt([
            'inline-block',
            'text-xlarge',
            'font-open-sans-bold',
            'leading-6',
            'text-brand-red',
        ]);
        const buttonWrapperCss = dt(['ml-4', 'md:ml-6', 'lg:ml-4', 'xl:ml-8', 'my-auto']);
        const couponIconWrapperCss = dt(['lg:ml-0', 'text-black', 'mr-2']);
        const noCouponWrapperCSs = dt(['flex', 'items-center', 'lg:mx-2']);
        const findBestCouponTextCss = dt([
            'text-small',
            'font-open-sans-semibold',
            'text-left',
            'text-brand-red',
            'self-center',
        ]);

        return (
            <section className={dt(['text-center'])}>
                <div
                    data-automation-id="findBestCoupon"
                    className={dt([
                        'rounded-lg',
                        'border-dashed',
                        'text-gray-200',
                        'bg-white-100',
                        'mb-4',
                        'smMd:mb-2',
                        'lg:mb-4',
                        'mt-4',
                        'border-2',
                        'border-gray-15',
                    ])}
                >
                    <div
                        data-automation-id="at-find-best-coupon-link-wrapper"
                        className={dt([
                            'flex',
                            'row-nowrap',
                            'justify-center',
                            'py-3',
                            'px-3',
                            'lg:px-6',
                        ])}
                    >
                        {enableBestCouponCTA ? (
                            <div className={cx(couponLink)}>
                                <div
                                    id={AMR_CART_VIEW_TODAYS_COUPONS}
                                    className={bestCouponWrapperCss}
                                    data-automation-id="at-best-coupon-wrapper"
                                >
                                    <div className={dt(['flex', 'items-center'])}>
                                        <div className={couponIconWrapperCss}>
                                            <Icon
                                                automationId="at-penny"
                                                iconType="svg"
                                                width="32px"
                                                height="32px"
                                                viewBox="0 0 32 32"
                                            >
                                                <CouponFill />
                                            </Icon>
                                        </div>
                                        <div
                                            data-automation-id="at-find-best-coupon"
                                            className={cx(findBestCouponCss)}
                                        >
                                            {fpacEnabledBestCouponText}
                                        </div>
                                    </div>
                                    <div id="buttonWrapper" className={buttonWrapperCss}>
                                        <Button
                                            btnDataId="viewCoupon"
                                            buttonId="today's-coupons-on-cart"
                                            buttonType="Secondary"
                                            size="Mini"
                                            automationId="at-find-best-coupon-link"
                                            className={dt([
                                                '!min-w-[70px]',
                                                'w-[70px]',
                                                'lg:!min-w-[104px]',
                                            ])}
                                            onClick={this.openCouponPanel}
                                        >
                                            View
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <section className={cx('noCouponWrapper', noCouponWrapperCSs)}>
                                <div className={couponIconWrapperCss}>
                                    <Icon
                                        automationId="at-penny"
                                        iconType="svg"
                                        width="32px"
                                        height="32px"
                                        viewBox="0 0 40 40"
                                    >
                                        <CouponFill />
                                    </Icon>
                                </div>
                                <div
                                    data-automation-id="at-no-coupon-text"
                                    className={cx('findBestCouponText', findBestCouponTextCss)}
                                >
                                    {noCouponText}
                                </div>
                            </section>
                        )}
                    </div>
                </div>
            </section>
        );
    }
}

const mapStateToProps = (state) => ({
    fpacEnabledBestCouponText: get(
        state,
        'context.messagesTexts.couponText.fpacEnabledBestCouponText',
        ''
    ),
    noCouponText: get(state, 'context.messagesTexts.couponText.noCoupon', ''),
    enableBestCouponCTA: get(state, 'context.featureFlags.enableBestCouponCTA', true),
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            ...slidePanelActions,
            ...coCouponActions,
            ...checkoutAnalyticsAction,
            ...serviceErrorActions,
        },
        dispatch
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(FindBestCoupon);
